import { Navigate, useLocation } from 'react-router-dom'
import useAuthStore from '../stores/authStore'
import { useEffect, useState } from 'react'

export default function ProtectedRoute({ children, requiredRole }) {
    const { isAuthenticated, user, checkAuth, isAdmin, isChecker, isCashier } = useAuthStore()
    const [isChecking, setIsChecking] = useState(true)
    const location = useLocation()

    useEffect(() => {
        const verify = async () => {
            await checkAuth()
            setIsChecking(false)
        }
        verify()
    }, [checkAuth])

    if (isChecking) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
            </div>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (requiredRole === 'admin' && !isAdmin() && !isCashier()) {
        return <Navigate to="/" replace />
    }

    if (requiredRole === 'checker' && !isChecker() && !isAdmin()) {
        return <Navigate to="/" replace />
    }

    return children
}
